import { useNavigate } from "react-router";

export const PaymentFailurePage = () => {
  const navigate = useNavigate();

  const handleContinueShopping = () => {
    navigate("/");
  };

  return (
    <div className="min-h-screen w-full bg-gray-50">
      {/* Main Content */}
      <div className="pt-8 pb-32">
        <div className="px-5 space-y-6">
          {/* Failure Message */}
          <div className="text-center py-8">
            <div className="w-20 h-20 bg-red-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg
                className="w-10 h-10 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </div>
            <h1 className="text-2xl font-bold text-black mb-2">
              Payment Failed
            </h1>
            <p className="text-gray-600 mb-4">
              We couldn't process your payment at this time
            </p>
          </div>

          {/* Refund Information */}
          <div className="p-6 bg-blue-50 rounded-lg border border-blue-200">
            <div className="flex items-start space-x-3">
              <div className="flex-shrink-0">
                <svg
                  className="w-6 h-6 text-blue-600 mt-0.5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>
              <div>
                <h3 className="text-lg font-semibold text-blue-900 mb-2">
                  Don't Worry About Your Money
                </h3>
                <p className="text-blue-800 leading-relaxed">
                  If any amount has been deducted from your account during this
                  transaction, it will be automatically refunded to the same
                  account within 3-5 business days. You will receive a
                  confirmation email once the refund is processed.
                </p>
              </div>
            </div>
          </div>

          {/* Common Issues */}
          <div className="p-4 bg-white rounded-lg border border-gray-100 shadow-sm">
            <h3 className="font-semibold text-gray-900 mb-3">
              Common Reasons for Payment Failure:
            </h3>
            <ul className="space-y-2 text-sm text-gray-600">
              <li className="flex items-start space-x-2">
                <span className="text-red-500 mt-1">•</span>
                <span>Insufficient funds in your account</span>
              </li>
              <li className="flex items-start space-x-2">
                <span className="text-red-500 mt-1">•</span>
                <span>Card has expired or is blocked</span>
              </li>
              <li className="flex items-start space-x-2">
                <span className="text-red-500 mt-1">•</span>
                <span>Network connectivity issues</span>
              </li>
              <li className="flex items-start space-x-2">
                <span className="text-red-500 mt-1">•</span>
                <span>Bank's security measures</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Fixed Action Button */}
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-4">
        <button
          onClick={handleContinueShopping}
          className="w-full bg-[#1e4aa8] text-white py-3 px-4 rounded-lg font-semibold hover:bg-[#1a3f8f] transition-colors"
        >
          Continue Shopping
        </button>
      </div>
    </div>
  );
};
